import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { usePlanStore } from '@/store/erp/system-settings/plan.store';
import { useTypeInstalation } from '@/store/erp/system-settings/type-instalation';
import { useCategoriaProductoStore, useFlotasStore, useGeographyStore } from '@/store/erp';
import { usePaymentMethodsStore } from '@/store/erp/system-settings/payment-methods';

export type ActivacionesProps = {};

const Activaciones: React.FC<ActivacionesProps> = () => {
  const getZones = useGeographyStore(s => s.getZones);
  const getSectors = useGeographyStore(s => s.getSectors);
  const getPlans = usePlanStore(s => s.getPlans);
  const getFlotas = useFlotasStore(s => s.getFlotas);
  const getTypeInstalation = useTypeInstalation(s => s.getTypeInstalation);
  const { getCategoriaProducto } = useCategoriaProductoStore();
  const { getpaymentMethodsFilterPaging } = usePaymentMethodsStore();

  useEffect(() => {
    (async () => {
      await Promise.all([
        getFlotas({
          page_size: 1000,
        }),
        getZones({
          page_size: 1000,
        }),
        getSectors({
          page_size: 1000,
        }),
        getPlans({
          page_size: 1000,
        }),
        getTypeInstalation({
          page_size: 1000,
        }),
        getCategoriaProducto({
          page_size: 1000,
        }),
        getpaymentMethodsFilterPaging({
          aplica_home:false,
          aplica_pyme:false,
          aplica_corporativo:false
        })
      ]);
    })();
  }, []);

  return (
    <>
      <Outlet />
     
      
    </>
  );
};

export default Activaciones;
